export const studentGrades = {
	type: 'array',
	items: {
		type: 'object',
		required: [
			'id',
			'startDate',
			'endDate'
		],
		properties: {
			id: {
				type: 'integer'
			},
			startDate: {
				type: 'string',
				format: 'date-time'
			},
			endDate: {
				type: 'string',
				format: 'date-time'
			},
			courses: {
				$ref: '/student-courses'
			}
		}
	}
};